import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tax-detail',
  templateUrl: './tax-detail.component.html',
  styleUrls: ['./tax-detail.component.scss']
})
export class TaxDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
